/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendDocument/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SendDocument({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/SendDocument"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let editorSavingValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'saving',
})
let editorDisabledValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'disabled',
})
let aggregateData = fromAggregate.any(editorSavingValueData, editorDisabledValueData)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content'))}
 data="editor.saving"
 data="editor.disabled"
 aggregate="/Simple/Data/aggregate.js any"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send document"
/>
)}
</TysiaButton>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}